import classNames from 'classnames';
import PropTypes from 'prop-types';
import type * as React from 'react';
import type MiniUser from '../../../../types/MiniUser';
import type { AvatarSize } from './service';
import { getClassName, getUrlForSize } from './service';
import styles from './style.m.less';

type Props = {
    user: MiniUser;
    size?: AvatarSize;
    isRound?: boolean;
    className?: string;
    ariaHidden?: boolean;
};

const Avatar: React.FC<Props> = ({ user, size = 'MD', isRound = true, className, ariaHidden }) => {
    const sizeClass = getClassName(size);
    return (
        <img
            src={getUrlForSize(user, size)}
            className={classNames({ [styles.round]: isRound }, sizeClass, className)}
            title={ariaHidden ? undefined : user.name}
            alt=""
            aria-hidden={ariaHidden}
        />
    );
};

Avatar.propTypes = {
    user: PropTypes.any.isRequired,
    size: PropTypes.any,
    isRound: PropTypes.bool,
    className: PropTypes.string,
    ariaHidden: PropTypes.bool,
};

export default Avatar;
